/* istanbul ignore file */
// we don't test SVGs without arguments
import React from 'react'
import { string } from 'prop-types'
const ArrowIconOpen = ({ fill, ...rest }) => (
  <svg {...rest}>
    <g
      fill={fill}
      fillRule="evenodd"
      stroke="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    >
      <polyline
        points="5 -8.24229573e-13 10 5 5 10"
        stroke="#757575"
        strokeWidth="2.5"
        transform="translate(7.500000, 5.000000) rotate(-90.000000) translate(-7.500000, -5.000000) "
      />
    </g>
  </svg>
)
ArrowIconOpen.defaultProps = {
  height: '10px',
  width: '15px',
  fill: 'none',
  viewBox: '0 0 15 10',
}
ArrowIconOpen.propTypes = {
  fill: string,
  height: string,
  viewBox: string,
  width: string,
}
export default ArrowIconOpen
